import React from "react";
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function ReadyToScale() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section data-section-id="22720" id="ready-to-scale-your-revenue" ref={ref} className="dark bg-[#000000] text-white relative flex min-h-[50vh] flex-col items-center justify-center overflow-hidden py-24 px-4">
      {}
      <div className="absolute inset-0 z-0">
        {}
        {}
        
        {}
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 h-[300px] w-[300px] rounded-full bg-[#FF6600]/10 blur-[100px]" />
      </div>

      <div className={`relative z-10 flex flex-col items-center text-center transition-all duration-1000 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
        <h2 className="font-sans text-4xl font-bold tracking-tight sm:text-5xl md:text-6xl lg:text-7xl mb-10 drop-shadow-lg text-white">
          Ready to Scale Your Revenue?
        </h2>

        <div className="relative group">
          {}
          <div className="absolute -inset-1 rounded-none bg-[#FF6600]/30 blur-lg transition-all duration-500 group-hover:bg-[#FF6600]/50 group-hover:blur-xl opacity-70" />
          
          <Link to="/ContactPage">
            <Button size="lg" className="relative h-14 px-10 text-lg font-bold uppercase bg-[#FF6600] text-white hover:bg-[#FF6600]/90 rounded-none shadow-xl transition-transform duration-300 hover:scale-105">
              Schedule a Consultation
              <ArrowRight className="ml-2 h-5 w-5" />
            </Button>
          </Link>
        </div>
      </div>
    </section>;
}